import {
    BoVisibilityFeature,
    BoVisibilityFeatureConditions,
} from './feature-visibility.backoffice.types';

/**
 *  To be visible, each feature condition property must have at least
 *  one of the provided values returned as true for the FI or user.
 */
export const BoVisibilityFeatureConditionMap = new Map<
    BoVisibilityFeature,
    BoVisibilityFeatureConditions
>([]);
